import { Checkbox, FormControlLabel, Stack, useTheme } from "@mui/material";
import { forwardRef, useEffect, useImperativeHandle, useRef, useState } from "react";

const activeCellEditor = forwardRef((props,ref) => {
    const refInput = useRef()
    const theme = useTheme();
    const [ active, setActive] = useState(props.value)
    const handleChangeSelected = (value) => {
        setActive(value)
        const rowData = props.node;
        rowData.setDataValue('active', value)
    }
    useImperativeHandle(ref, () => {
        return {
            getValue() {
                    return active
            },
            focusIn() {
                var eInput = refInput.current;
                // if (eInput) {
                eInput.focus();
                eInput.select();
                // }
            }
        };
    });

    useEffect(() => {
        // get ref from React component
        window.setTimeout(() => {
            const eInput = refInput.current;
            eInput.focus();
        });
    },[]);

    return (
        <Stack sx={{
            backgroundColor: theme.palette. background.paper
        }}>
            <Checkbox
            ref={refInput}
            checked={active}
            size="small"
                onChange={(e) => handleChangeSelected(e.target.checked)}
                sx={{
                    padding:0,
                    width:'inherit',
                    backgroundColor:theme.palette. background.paper
                }}
            />   
            </Stack>                          
    )

})

export default activeCellEditor;